var _desc, _circle, _polygon, _polygon2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatAssistantIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 172,
    viewBox: "48 32 144 172",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AI Chat Assistant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Navy chat bubble avatar with a yellow geometric AI mark and tail.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 72,
    fill: "#124066"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90,167 65,204 117,172",
    fill: "#124066"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "120,49 150,79 138,113 98,113",
    fill: "#FBD359"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 65,
    r: 6,
    fill: "#FBD359"
  })), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 145,
    textAnchor: "middle",
    style: {
      fill: "#FBD359",
      fontWeight: 700,
      fontSize: 11,
      letterSpacing: "0.45px",
      fontFamily: "Arial,Helvetica,sans-serif"
    }
  }, "\n    AI Chat Assistant\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatAssistantIconRound);
export default __webpack_public_path__ + "static/media/AI_Chat_Assistant_Icon_round.c2cdade4d3ab115362920d3f5d5c682b.svg";
export { ForwardRef as ReactComponent };